import * as React from 'react';
import Layer from '../data/Layer';
import { getStoreState, storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import LiveComponent from '../components/LiveComponent';
import { TIMELINE_VISIBILITY_KEY } from '../data/LayerTimeline';
import { ItemValue } from '../components/SelectRich';
import { EffectTimelineView } from './EffectTimelineView';

interface Props {
  layer: Layer;
}

class LayerTimelineView extends LiveComponent<Props> {
  containerEl = React.createRef<HTMLDivElement>();
  needle = React.createRef<HTMLDivElement>();
  motionSource = getStoreState().flyer.motionSource;

  canvasWidth = 280;
  isDraggingNeedle = false;
  leftOffset = 0;

  componentDidMount() {
    super.componentDidMount();

    if (this.containerEl.current) {
      const { left, width } = this.containerEl.current.getBoundingClientRect();
      this.canvasWidth = width;
      this.leftOffset = left;
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();

    window.removeEventListener('mousemove', this.didMoveNeedle);
    window.removeEventListener('mouseup', this.didReleaseNeedle);
  }

  tick() {
    if (this.isDraggingNeedle) {
      return;
    }
    const needle = this.needle.current;
    if (needle) {
      const width = this.canvasWidth;
      const position = this.motionSource.getNormalisedPosition();
      needle.style.transform = `translateX(${width * position}px)`;
    }
  }

  didGrabNeedle = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!this.needle.current) {
      return;
    }
    this.isDraggingNeedle = true;
    window.addEventListener('mousemove', this.didMoveNeedle);
    window.addEventListener('mouseup', this.didReleaseNeedle);
  };

  didMoveNeedle = (e: MouseEvent) => {
    const needle = this.needle.current;
    if (!needle) {
      return;
    }
    let position = (e.clientX - this.leftOffset) / this.canvasWidth;
    position = Math.max(0, Math.min(1, position));
    needle.style.transform = `translateX(${this.canvasWidth * position}px)`;
  };

  didReleaseNeedle = (e: MouseEvent) => {
    // seek motionsource
    this.isDraggingNeedle = false;
    if (this.needle.current) {
      let position = (e.clientX - this.leftOffset) / this.canvasWidth;
      position = Math.max(0, Math.min(1, position));
      const time = position * this.motionSource.getDuration();
      storeDispatch(Actions.jumpPlayback(time));
    }
    window.removeEventListener('mousemove', this.didMoveNeedle);
    window.removeEventListener('mouseup', this.didReleaseNeedle);
  };

  render() {
    const { layer } = this.props;
    const channelOptions: ItemValue[] = [
      {
        id: TIMELINE_VISIBILITY_KEY,
        label: 'Visibility'
      }
    ];
    for (const fx of layer.effects.filter(f => f.visible)) {
      const { id, label } = fx.constructor as any;
      channelOptions.push({
        id,
        label
      });
    }
    return (
      <div ref={this.containerEl} className="layer-timeline">
        {channelOptions.map(effect => (
          <EffectTimelineView layer={layer} effect={effect} key={effect.id} />
        ))}
        <div
          ref={this.needle}
          onMouseDown={this.didGrabNeedle}
          className="needle"
        />
      </div>
    );
  }
}

export { LayerTimelineView };



// WEBPACK FOOTER //
// ./src/controller/LayerTimelineView.tsx